<template>
  <RateConnectOnboardingHero />
  <RateConnectSuccessStories />
  <RateConnectVideo />
  <RateConnectBenefits />
  <RateConnectGuide />
  <HowToStart />
</template>
<script setup>
import RateConnectBenefits from '@/components/rateConnect/onboarding/RateConnectBenefits.vue'
import RateConnectOnboardingHero from '@/components/rateConnect/onboarding/RateConnectOnboardingHero.vue'
import RateConnectSuccessStories from '@/components/rateConnect/onboarding/RateConnectSuccessStories.vue'
import RateConnectVideo from '@/components/rateConnect/onboarding/RateConnectVideo.vue'
import RateConnectGuide from '@/components/rateConnect/onboarding/RateConnectGuide.vue'
import HowToStart from '@/components/rateConnect/onboarding/HowToStart.vue'
</script>
